import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import type { Document } from '@contentful/rich-text-types';

import type { ContentResponseBody } from '@sola/schema/lib/contentful.ts';

export const getPlainTextFromRichTextBody = (
  body: ContentResponseBody | null | undefined,
): string => {
  if (!body?.json) {
    return '';
  }

  return documentToPlainTextString(body.json as unknown as Document)
    .replaceAll(/\s+/g, ' ')
    .trim();
};
